import { HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MainAPIConfiguration } from 'wflow-main-app/src/app/core/api/api/configuration';
import { getOrg } from 'wflow-main-app/src/app/shared/utils/route.utils';
import { AbstractApiRequest } from '../../abstract/api-request.abstract';

@Injectable({
  providedIn: 'root',
})
export class DocumentsImportAPIService extends AbstractApiRequest {
  override readonly configuration = inject(MainAPIConfiguration);

  public importDocument(
    format: string,
    file: Blob,
    organization?: string,
  ): Observable<HttpEvent<string>> {
    if (organization == null) {
      organization = getOrg();
      if (organization == null) {
        throw new Error(
          `Required parameter organization was null or undefined when calling importDocument.`,
        );
      }
    }

    if (!format) {
      throw new Error(
        'Required parameter format was not supplied when calling importDocument.',
      );
    }

    if (file == null) {
      throw new Error(
        'Required parameter file was not supplied when calling importDocument.',
      );
    }

    let params = {};

    let formParams = new FormData();
    formParams.append('file', file);

    return this.postRequest<HttpEvent<string>>({
      url: `${encodeURIComponent(
        String(organization),
      )}/documents/import/${format}`,
      params: params,
      observe: 'body',
      reportProgress: true,
      uploadFile: true,
    })(formParams);
  }
}
